var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanelOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Panel_open") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Panel_open",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8281789,17.8281789 C18.585673,18.0706972 18.256757,18.2069437 17.9137931,18.2069437 C17.5708292,18.2069437 17.2419132,18.0706972 16.9994073,17.8281789 L11.4482759,12.2769935 L11.4482759,10.4482759 L13.2769935,10.4482759 L18.8281789,15.9994073 C19.0706972,16.2419132 19.2069437,16.5708292 19.2069437,16.9137931 C19.2069437,17.256757 19.0706972,17.585673 18.8281789,17.8281789 L18.8281789,17.8281789 Z M29.5517241,28.5517241 L29.5517241,26.7230065 L24.0005927,21.1718211 C23.4955914,20.6668198 22.6768224,20.6668198 22.1718211,21.1718211 C21.6668198,21.6768224 21.6668198,22.4955914 22.1718211,23.0005927 L27.7230065,28.5517241 L29.5517241,28.5517241 Z M10.5862069,15.1896552 L10.5862069,9.5862069 L16.1896552,9.5862069 C16.9038165,9.5862069 17.4827586,9.00726476 17.4827586,8.29310345 C17.4827586,7.57894213 16.9038165,7 16.1896552,7 L9.29310345,7 C8.57894213,7 8,7.57894213 8,8.29310345 L8,15.1896552 C8,15.9038165 8.57894213,16.4827586 9.29310345,16.4827586 C10.0072648,16.4827586 10.5862069,15.9038165 10.5862069,15.1896552 Z M33,30.7068966 L33,23.8103448 C33,23.0961835 32.4210579,22.5172414 31.7068966,22.5172414 C30.9927352,22.5172414 30.4137931,23.0961835 30.4137931,23.8103448 L30.4137931,29.4137931 L24.8103448,29.4137931 C24.0961835,29.4137931 23.5172414,29.9927352 23.5172414,30.7068966 C23.5172414,31.4210579 24.0961835,32 24.8103448,32 L31.7068966,32 C32.4210579,32 33,31.4210579 33,30.7068966 Z",
    id: "Shape",
    fill: "#FAF9FB",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelOpen);
export default __webpack_public_path__ + "static/media/panel_open.472f6ccf7687d02e82c9d7c7209a9ba7.svg";
export { ForwardRef as ReactComponent };